import firebase from 'firebase'
import 'firebase/auth'
import 'firebase/firestore'



const app = firebase.initializeApp({
  // apiKey: process.env.REACT_APP_FIREBASE_KEY,
  // authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  // databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
  // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  // appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  apiKey: "AIzaSyBz0I-hOrx0YgHaH8lzDq2nUL2aAqlHbIU",
  authDomain: "bloomhope-20881.firebaseapp.com",
  databaseURL: "https://bloomhope-20881.firebaseio.com",
  projectId: "bloomhope-20881",
  storageBucket: "bloomhope-20881.appspot.com",
  messagingSenderId: "245858003986",
  appId: "1:245858003986:web:e69aa145369bd5e2237ccb",
  measurementId: "G-4T2SQGG5QW"

})

export const auth = app.auth()
export const db = app.firestore()

